// extracted by mini-css-extract-plugin
export default {"articles":"Zin_articles__ic1oS"};